// Hypnowheel selectors
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

export const selectHypnowheel = (state: RootState) => state.hypnowheel.data;
export const selectHypnowheelLoading = (state: RootState) => state.hypnowheel.loading;
export const selectHypnowheelError = (state: RootState) => state.hypnowheel.error;

export const selectNextDay = createSelector(
  [selectHypnowheel],
  (hypnowheel) => hypnowheel?.data[0] || 0
);

export const selectNextDayAvailableIn = createSelector([selectHypnowheel], (hypnowheel) =>
  hypnowheel?.data[1] > 0 ? hypnowheel?.data[1] : undefined
);

export const selectNextGame = createSelector(
  [selectHypnowheel],
  (hypnowheel) => hypnowheel?.data[2] || ''
);
